<div class="flexbox is-pointer py-2 is-align-items-center">
  <img class="avatar mr-1" [src]="userProfileImageUrl || 'assets/images/featured-cover-art.png'" />
  <span [routerLink]="['/profile', userName]">
    {{ displayName }}
  </span>
</div>
